(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumora-whatsapp"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lumora-whatsapp')) {
  customElements.define('lumora-whatsapp', class extends HTMLElement {
    connectedCallback() {
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.updatePosition(); });
      };
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.schedule();
      });
      this.observer.observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['class','open','style','hidden']});
      this.resizeObserver = new ResizeObserver(this.schedule);
      document.querySelectorAll('.sticky-atc').forEach(element => this.resizeObserver.observe(element));
      window.addEventListener('resize', this.schedule, {passive:true});
      window.addEventListener('scroll', this.schedule, {passive:true});
      document.addEventListener('animationend', this.schedule);
      this.schedule();
    }
    updatePosition() {
      const overlay = document.querySelector('cart-drawer.active, .quick-add-modal[open], .product-media-modal[open], dialog[open]');
      this.hidden = Boolean(overlay);
      let obstruction = 0;
      document.querySelectorAll('.sticky-atc').forEach(element => {
        const style = getComputedStyle(element);
        const active = !element.classList.contains('sticky-atc--after-scroll') || element.classList.contains('sticky-atc--active');
        if (active && style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length) {
          obstruction = Math.max(obstruction, element.offsetHeight + Math.max(0, parseFloat(style.bottom) || 0));
        }
      });
      const next = obstruction + 'px';
      if (this.style.getPropertyValue('--wa-obstruction') !== next) this.style.setProperty('--wa-obstruction', next);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      window.removeEventListener('resize', this.schedule);
      window.removeEventListener('scroll', this.schedule);
      document.removeEventListener('animationend', this.schedule);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-media"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shoppable-media')) {
    customElements.define('shoppable-media', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.sm__track');
        this.originals = [...this.track.children].filter(item => !item.hasAttribute('data-clone'));
        this.originals.forEach((item, index) => item.dataset.logicalIndex = index);
        this.states = this.originals.map(() => ({ muted: true, paused: false, time: 0, manual: false }));
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.logicalIndex = this.originals.length > 2 ? 1 : 0;
        this.activeItem = this.originals[this.logicalIndex];
        this.items = this.originals;
        this.inView = false;
        this.positioning = true;
        this.layoutWidth = 0;
        this.querySelector('.sm__navigation')?.removeAttribute('hidden');
        this.addEventListener('click', event => {
          const arrow = event.target.closest('[data-direction]');
          if (arrow) this.step(Number(arrow.dataset.direction));
          const button = event.target.closest('[data-action]');
          if (!button) return;
          const item = button.closest('.sm__item');
          const index = Number(item.dataset.logicalIndex);
          const state = this.states[index];
          if (button.dataset.action === 'mute') {
            state.muted = !state.muted;
            item.querySelector('video').muted = state.muted;
            this.updateControls(item);
            return;
          }
          const wasPlaying = !item.querySelector('video').paused;
          this.centerOriginal(index);
          state.paused = wasPlaying;
          state.manual = !wasPlaying;
          this.sync();
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.measure());
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.rebase(), 140);
        }, { ...options, passive: true });
        this.track.addEventListener('scrollend', () => this.rebase(), options);
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.step(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        document.addEventListener('shopify:block:select', event => {
          const index = this.originals.findIndex(item => item.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.centerOriginal(index);
        }, options);
        this.motion.addEventListener('change', () => this.sync(), options);
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0.25 });
        this.visibilityObserver.observe(this.track);
        this.resizeObserver = new ResizeObserver(() => this.positionLayout());
        this.resizeObserver.observe(this.track);
        window.addEventListener('load', () => this.positionLayout(), options);
        this.positionLayout();
      }
      cloneItem(original) {
        const clone = original.cloneNode(true);
        clone.dataset.clone = 'true';
        clone.removeAttribute('data-block-id');
        [clone, ...clone.querySelectorAll('*')].forEach(node => {
          [...node.attributes].forEach(attribute => {
            if (attribute.name === 'id' || attribute.name.startsWith('data-shopify') || attribute.name === 'aria-controls' || attribute.name === 'aria-labelledby' || attribute.name === 'aria-describedby') node.removeAttribute(attribute.name);
          });
        });
        clone.setAttribute('aria-hidden', 'true');
        clone.querySelectorAll('a,button,video,[tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
        return clone;
      }
      positionLayout() {
        this.positioning = true;
        cancelAnimationFrame(this.layoutFrame);
        cancelAnimationFrame(this.settleFrame);
        this.layoutFrame = requestAnimationFrame(() => {
          if (!this.isConnected || getComputedStyle(this.track).display !== 'flex' || !this.track.clientWidth) return;
          this.pauseAll();
          this.mediaController?.abort();
          this.mediaController = new AbortController();
          this.track.querySelectorAll('[data-clone]').forEach(item => item.remove());
          this.layoutWidth = this.track.clientWidth;
          const step = this.originals[0].offsetWidth + parseFloat(getComputedStyle(this.track).columnGap || 0);
          const copies = this.originals.length > 1 ? Math.ceil((this.layoutWidth / Math.max(step, 1) + 2) / this.originals.length) : 0;
          const before = document.createDocumentFragment();
          const after = document.createDocumentFragment();
          for (let copy = 0; copy < copies; copy++) {
            this.originals.forEach(item => { before.append(this.cloneItem(item)); after.append(this.cloneItem(item)); });
          }
          this.track.prepend(before);
          this.track.append(after);
          this.items = [...this.track.children];
          this.items.forEach(item => {
            const video = item.querySelector('video');
            if (!video) return;
            video.controls = false;
            video.muted = this.states[Number(item.dataset.logicalIndex)].muted;
            item.querySelector('.sm__controls').hidden = false;
            ['play', 'pause', 'volumechange'].forEach(event => video.addEventListener(event, () => this.updateControls(item), { signal: this.mediaController.signal }));
            this.updateControls(item);
          });
          this.activeItem = this.originals[this.logicalIndex];
          this.scrollToItem(this.activeItem, true);
          this.settleFrame = requestAnimationFrame(() => {
            this.positioning = false;
            this.dataset.ready = 'true';
            this.sync();
          });
        });
      }
      scrollToItem(item, instant = false, offset = 0) {
        if (!item) return;
        const trackBox = this.track.getBoundingClientRect();
        const box = item.getBoundingClientRect();
        this.track.scrollBy({ left: box.left + box.width / 2 - trackBox.left - trackBox.width / 2 - offset, behavior: instant || this.motion.matches ? 'instant' : 'smooth' });
      }
      centerOriginal(index) {
        this.pauseAll();
        this.logicalIndex = ((index % this.originals.length) + this.originals.length) % this.originals.length;
        this.activeItem = this.originals[this.logicalIndex];
        this.scrollToItem(this.activeItem, true);
        this.sync();
      }
      step(direction) {
        if (this.positioning || this.originals.length < 2) return;
        this.rebase();
        const index = this.items.indexOf(this.activeItem);
        this.scrollToItem(this.items[index + direction]);
      }
      measure() {
        if (this.positioning) return;
        if (this.track.clientWidth !== this.layoutWidth) { this.positionLayout(); return; }
        const box = this.track.getBoundingClientRect();
        const center = box.left + box.width / 2;
        let nearest = Infinity;
        let active = this.activeItem;
        this.items.forEach(item => {
          const rect = item.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          if (distance < nearest) { nearest = distance; active = item; }
        });
        if (active !== this.activeItem) this.pauseAll();
        this.activeItem = active;
        this.logicalIndex = Number(active.dataset.logicalIndex);
        this.sync();
      }
      rebase() {
        if (this.positioning || !this.activeItem?.hasAttribute('data-clone')) return;
        this.pauseAll();
        const box = this.track.getBoundingClientRect();
        const activeBox = this.activeItem.getBoundingClientRect();
        const offset = activeBox.left + activeBox.width / 2 - box.left - box.width / 2;
        const focused = this.activeItem.contains(document.activeElement);
        const action = document.activeElement?.dataset.action;
        this.activeItem = this.originals[this.logicalIndex];
        this.track.classList.add('is-rebasing');
        this.scrollToItem(this.activeItem, true, offset);
        if (focused) (action ? this.activeItem.querySelector('[data-action="' + action + '"]') : this.activeItem.querySelector('a'))?.focus({ preventScroll: true });
        cancelAnimationFrame(this.rebaseFrame);
        this.rebaseFrame = requestAnimationFrame(() => this.track.classList.remove('is-rebasing'));
        this.sync();
      }
      pauseAll() {
        this.items.forEach(item => {
          const video = item.querySelector('video');
          if (!video) return;
          if (item === this.activeItem) this.states[Number(item.dataset.logicalIndex)].time = video.currentTime || 0;
          video.pause();
        });
      }
      sync() {
        const canPlay = this.inView && !document.hidden && !this.positioning;
        const autoplay = this.dataset.autoplay === 'true' && !this.motion.matches && !navigator.connection?.saveData;
        this.items.forEach(item => {
          const active = item === this.activeItem;
          item.classList.toggle('is-active', active);
          item.querySelectorAll('a,button').forEach(node => node.setAttribute('tabindex', active && !item.hasAttribute('data-clone') ? '0' : '-1'));
          const video = item.querySelector('video');
          if (!video) return;
          const state = this.states[Number(item.dataset.logicalIndex)];
          if (!active || !canPlay || state.paused || (!autoplay && !state.manual)) { video.pause(); return; }
          video.muted = state.muted;
          if (video.paused) {
            if (Math.abs(video.currentTime - state.time) > .25) { try { video.currentTime = state.time; } catch {} }
            video.play().catch(() => this.updateControls(item));
          }
        });
        this.querySelectorAll('[data-direction]').forEach(button => button.disabled = this.originals.length < 2);
      }
      updateControls(item) {
        const video = item.querySelector('video');
        const play = item.querySelector('[data-action="play"]');
        const mute = item.querySelector('[data-action="mute"]');
        play.setAttribute('aria-label', video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        play.setAttribute('aria-pressed', String(!video.paused));
        play.querySelector('[data-icon]').textContent = video.paused ? '▶' : 'Ⅱ';
        mute.setAttribute('aria-label', video.muted ? this.dataset.unmuteLabel : this.dataset.muteLabel);
        mute.setAttribute('aria-pressed', String(video.muted));
        mute.querySelector('[data-icon]').textContent = video.muted ? '♪×' : '♪';
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.mediaController?.abort();
        this.visibilityObserver?.disconnect();
        this.resizeObserver?.disconnect();
        [this.frame, this.layoutFrame, this.settleFrame, this.rebaseFrame].forEach(frame => cancelAnimationFrame(frame));
        clearTimeout(this.scrollTimer);
        this.pauseAll();
        this.track.querySelectorAll('[data-clone]').forEach(item => item.remove());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
